import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["Pending", "Confirmed", "Preparing", "Ready for Pickup", "Out for Delivery", "Completed", "Cancelled"];

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("All");
  const load = () => {
    const params = filter !== "All" ? { status: filter } : {};
    api.get("/orders", { params }).then(({data}) => setOrders(data)).catch(() => {});
  };
  useEffect(() => { load(); }, [filter]);

  const update = async (id, status) => {
    await api.patch(`/orders/${id}/status`, { status });
    toast.success("Status updated");
    load();
  };

  return (
    <div data-testid="orders-page">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-4">Orders</h1>
      <div className="flex flex-wrap gap-2 mb-5">
        {["All", ...STATUSES].map(s => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`order-filter-${s.toLowerCase().replace(/\s/g, '-')}`} className={`px-3 py-1.5 text-xs font-accent uppercase tracking-wider ${filter === s ? "bg-[#D4AF37] text-[#050505]" : "border border-[#D4AF37]/40 text-[#D4AF37]"}`}>{s}</button>
        ))}
      </div>
      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-[#D4AF37]/15">
            <tr className="text-left text-[#D4AF37]/80 text-xs uppercase tracking-wider">
              <th className="p-3">Order #</th>
              <th className="p-3">Customer</th>
              <th className="p-3">Type</th>
              <th className="p-3">Total</th>
              <th className="p-3">Status</th>
              <th className="p-3">Created</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id} className="border-b border-[#D4AF37]/5 hover:bg-white/5" data-testid={`order-row-${o.id}`}>
                <td className="p-3 font-accent text-[#D4AF37]">{o.order_number}</td>
                <td className="p-3">{o.customer_name}</td>
                <td className="p-3">
                  <div className="flex gap-1">
                    {o.has_restaurant_items && <span className="badge-royal">CHOW</span>}
                    {o.has_grocery_items && <span className="badge-fresh">MART</span>}
                  </div>
                </td>
                <td className="p-3 text-[#D4AF37] font-semibold">${o.total.toFixed(2)}</td>
                <td className="p-3">
                  <select value={o.status} onChange={(e) => update(o.id, e.target.value)} data-testid={`order-status-${o.id}`} className="bg-[#0B0E14] border border-[#D4AF37]/30 px-2 py-1 text-xs text-[#FAF9F6] rounded">
                    {STATUSES.map(s => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="p-3 text-[#FAF9F6]/60 text-xs">{new Date(o.created_at).toLocaleString()}</td>
                <td className="p-3 text-xs">{o.payment_status}</td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-[#FAF9F6]/40">No orders</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
